<template>
  <div>
   <!-- <div class="table-title">
      <p class="table-name">标注任务</p>
    </div>-->
      <div style="width: 60%">
        <a-row :gutter="16">
          <a-col :span="8">
            <a-card title="待处理" :bordered="false">
              <p>{{pending}}</p>
            </a-card>
          </a-col>
          <a-col :span="8">
            <a-card title="处理中" :bordered="false">
              <p>{{process}}</p>
            </a-card>
          </a-col>
          <a-col :span="8">
            <a-card title="已完成" :bordered="false">
              <p>{{complete}}</p>
            </a-card>
          </a-col>
        </a-row>
      </div>
    <a-card style="margin: 10px 0">
      <div class="filter-section">
        <!-- <span>状态:</span>
        <a-select
          style="width: 140px"
          v-model:value="form.state"
        >
          <a-select-option key="全部" value="" title="全部">
            全部
          </a-select-option>
          <a-select-option key="未拆分">
            未拆分
          </a-select-option>
          <a-select-option key="已拆分">
            已拆分
          </a-select-option>
          <a-select-option key="未分配">
            未分配
          </a-select-option>
          <a-select-option key="已分配">
            已分配
          </a-select-option>
          <a-select-option key="标注中">
            标注中
          </a-select-option>
          <a-select-option key="审核中">
            审核中
          </a-select-option>
          <a-select-option key="已完成">
            已完成
          </a-select-option>
        </a-select> -->
        <a-form layout="inline" ref="form" :model="form">
          <a-form-item label="状态" name="state">
            <a-select
              style="width: 140px"
              v-model:value="form.state"
            >
              <a-select-option key="">
                全部
              </a-select-option>
              <a-select-option v-for="item in labelState" :key="item.state">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="名称" name="name">
            <a-input style="width: 200px" placeholder="请输入名称" v-model:value="form.name" autocomplete="off">
            </a-input>
          </a-form-item>
          <a-form-item>
            <a-button @click="resetForm">重置</a-button>
            <a-button type="primary" @click="getData()">查询</a-button>
          </a-form-item>
        </a-form>
      </div>
    </a-card>
    <a-card>
      <a-table
        :columns="columns"
        :data-source="tableData"
        rowKey="id"
        :pagination="false">
        <template v-slot:taskType="{ text }">
          {{ getTaskName(text) }}
        </template>
        <template v-slot:userId="{ text }">
          {{ getUserName(text) }}
        </template>
        <template v-slot:stateName="{ text }">
          {{ getSubStateName(text) }}
        </template>
        <template v-slot:pgress="{ text }">
          {{ getValue(text) }}
        </template>
        <template v-slot:time="{ text }">
          {{ getDateTime(text) }}
        </template>
        <template v-slot:finishTime="{ text }">
          {{ getDateTime(text) }}
        </template>
        <template v-slot:action="{ record }">
          <span class="gap-btn">
            <a @click="toDetail(record)">详情</a>
          </span>
          <span class="gap-btn">
            <a :class="record.state == 'waiting_annotate' ?'':'grey'"  @click="record.state == 'waiting_annotate'?labelHandle(record):''">标注</a>
          </span>
          <span class="gap-btn">
            <a :class="record.state == 'doing_annotation' ?'':'grey'" @click="record.state == 'doing_annotation'?handleSubmit(record):''">提交任务</a>
          </span>
        </template>
      </a-table>
      <br>
      <a-pagination
        :current="page.pageNum"
        show-quick-jumper
        :pageSize="10"
        :total="total"
        :show-total="total => `共 ${total} 条`"
        @change="getData"
      ></a-pagination>
    </a-card>
    <group-task-detail ref="taskDetail" :current-item="currentItem"></group-task-detail>
<!--    <task-detail ref="taskDetail" :current-item="currentItem"></task-detail>-->
  </div>
</template>
<script>
// import { SearchOutlined } from '@ant-design/icons-vue'
import { getMyRelease, updateTask } from '@/api/task'
import { getDateTime, getTaskName, getValue, getSubStateName, getUserName } from '@/filters'
// import TaskDetail from '../TaskRelease/TaskDetail'
import GroupTaskDetail from '../TaskAllocation/GroupTaskDetail'
import { Modal } from 'ant-design-vue'
const columns = [
  {
    title: '名称',
    dataIndex: 'name'
  },
  {
    title: '任务类型',
    dataIndex: 'taskTypeId',
    slots: { customRender: 'taskType' }
  },
  {
    title: '说明',
    dataIndex: 'description'
  },
  {
    title: '状态',
    dataIndex: 'state',
    slots: { customRender: 'stateName' }
  },
  {
    title: '标注进度',
    dataIndex: 'progress',
    slots: { customRender: 'pgress' }
  },
  {
    title: '发布人',
    dataIndex: 'createUserId',
    slots: { customRender: 'userId' }
  },
  {
    title: '创建时间',
    dataIndex: 'createTime',
    slots: { customRender: 'time' }
  },
  {
    title: '要求完成时间',
    dataIndex: 'planFinishTime',
    slots: { customRender: 'finishTime' }
  },
  {
    title: '操作',
    slots: { customRender: 'action' }
  }
]

export default {
  components: {
    // TaskDetail
    // SearchOutlined
    GroupTaskDetail
  },
  data () {
    return {
      labelState: [{ name: '待标注', state: 'waiting_annotate' },
        { name: '标注中', state: 'doing_annotation' },
        { name: '已标注', state: 'already_annotation' }],
      form: {
        state: '',
        name: ''
      },
      tableData: [],
      columns,
      page: {
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      currentItem: {},
      addition: '',
      pending: '--',
      process: '--',
      complete: '--'
    }
  },
  mounted () {
    this.getData(1)
  },
  methods: {
    getDateTime,
    getTaskName,
    getValue,
    getSubStateName,
    getUserName,
    resetForm () {
      this.$refs.form.resetFields()
    },
    getData (pageNum) {
      if (pageNum) this.page.pageNum = pageNum
      let s = ''
      if (this.form.state) {
        s = this.form.state
      } else {
        s = 'waiting_annotateviayieflagyieviadoing_annotationviayieflagyieviaalready_annotation'
      }
      getMyRelease({ ...this.form, ...this.page, state: s, parentId: 'notNullValue', field: 'createTime', order: 'desc' }).then(res => {
        const data = res.data.map.data
        this.total = data.total
        this.tableData = data.rows
        const pending = 0
        const process = 0
        const complete = 0
        for (let i = 0; i < data.rows.length; i++) {
          if (data.rows[i].state === 'waiting_annotate') {
            this.pending = pending + 1
          } else if (data.rows[i].state === 'doing_annotation') {
            this.process = process + 1
          } else if (data.rows[i].state === 'already_annotation') {
            this.complete = complete + 1
          }
        }
      })
    },
    // 数据处理
    dataProcess (raw) {
      return raw.map(i => ({ ...i, ...i.labourAssignRecord }))
    },
    toDetail (item) {
      this.currentItem = item
      this.$refs.taskDetail.open()
      // this.$router.push({ name: 'groupTaskDetail' })
    },
    labelHandle (item) {
      Modal.info({
        title: '',
        icon: '',
        content: '请打开在线版XXX进行标注，标注完成后记得回来提交任务！',
        onOk: () => {
          updateTask({
            id: item.id, state: 'doing_annotation'
          }).then(res => {
            this.getData(1)
          })
        }
      })
    },
    // 提交
    handleSubmit (item) {
      this.$confirm({
        title: '任务提交',
        content: '确认任务已完成，并提交？',
        okText: '是',
        okType: 'danger',
        cancelText: '否',
        onOk: () => {
          updateTask({
            id: item.id, state: 'already_annotation'
          }).then(res => {
            this.$message.success('操作成功')
            this.getData(1)
          })
        },
        onCancel () {
          console.log('cancel')
        }
      })    



      1
    },
  }
}
</script>
